import update from 'react-addons-update'

const effects = (state = [], action) => {
  switch (action.type) {
    case 'CHANGE_EFFECT':
      return state
    default:
      return state
  }
}
export default effects
